import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import HeaderLogo from "components/ComponentHtml/HeaderLogo";
import FooterOnePage from "components/ComponentHtml/FooterOnePage";
import TermsConditionsComponent from "components/ComponentHtml/TermsConditionsComponent";
import TermsConditionsDASComponent from "components/ComponentHtml/TermsConditionsDASComponent";

export default function TermsConditions() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const partnerEnv = process.env.REACT_APP_PARTNERSHIP;
  const partner = partnerEnv ? !!JSON.parse(partnerEnv) : false;

  console.log(partner);

  useEffect(() => {
    document.body.setAttribute("data-root", window.location.pathname);

    setTimeout(() => {
      setIsLoading(false);
    }, 100);

    return () => {
      document.body.removeAttribute("data-root");
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <div style={{ display: "none" }} />
      ) : (
        <>
          <HeaderLogo />
          {partner ? (
            <TermsConditionsDASComponent />
          ) : (
            <TermsConditionsComponent />
          )}
          <FooterOnePage />
        </>
      )}
    </>
  );
}
